import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

export const AI_APPLICATION_STATS_KEY = 'ai-application-stats';

const STALE_TIME_MS = 30_000;

export function useAiApplicationStats({
  aiApplicationId,
  enabled = true,
}: {
  aiApplicationId: string | null;
  enabled?: boolean;
}) {
  const query = useQuery({
    queryKey: [AI_APPLICATION_STATS_KEY, aiApplicationId],
    queryFn: () =>
      terraProxyApiClient.getAiApplicationStats(aiApplicationId ?? ''),
    enabled: Boolean(aiApplicationId) && enabled,
    staleTime: STALE_TIME_MS,
  });

  return {
    stats: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
